import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {Condition} from "./condition";
import {catchError, map, Observable, of} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ConditionsService {
  private jsonUrl = 'assets/config_data.json';

  constructor(private http: HttpClient) {}

  getAllConditions(): Observable<Condition[]> {
    return this.http.get<{ Conditions: Condition[] }>(this.jsonUrl).pipe(
      map(data => data.Conditions || []),
      catchError(error => {
        console.error('Error fetching Conditions:', error);
        return of([]); // Return an empty array if JSON fetching fails
      })
    );
  }
}
